// extracted by mini-css-extract-plugin
export var featuresBlock = "styles-module--featuresBlock--3sChS";
export var heading = "styles-module--heading--1KTlI";
export var featuresContainer = "styles-module--featuresContainer--1x8AB";
export var featureContent = "styles-module--featureContent--3BgLs";
export var featureTitleContainer = "styles-module--featureTitleContainer--1qfoc";
export var checkIcon = "styles-module--checkIcon--1qoqM";
export var featureTitle = "styles-module--featureTitle--3OYlV";